import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import MailchimpLegacy from './MailchimpLegacy';
import MailchimpNewBuilder from './MailchimpNewBuilder';

/**
 * Mailchimp section shell: nested routes for legacy vs SKU-based email builders.
 */
const MailchimpEmails = () => (
  <Switch>
    <Route exact path="/dashboard/emails/new" component={MailchimpNewBuilder} />
    <Route exact path="/dashboard/emails/old" component={MailchimpLegacy} />
    <Redirect exact from="/dashboard/emails" to="/dashboard/emails/new" />
  </Switch>
);

export default MailchimpEmails;
